import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';
import { removeProductFromWishlist, moveProductToCart } from '../modules/wishlist_actions';

class ModalWishlist extends Component {
  render() {
    let {dispatch} = this.props;
    let oWishlistItems = (
      <li className="full-width"><h6 className="center">Your wishlist is empty.</h6></li>
    );

    if ( this.props.customer && this.props.customer.wishlist ) {
      if ( this.props.customer.wishlist.length > 0 ) {
        oWishlistItems = this.props.customer.wishlist.map(oItem => {
          let lpMedallion         = oItem.format === 'large_print' ? <img src={"/images/theme-default/lp-icon.svg"} /> : '';
          let sImageSrc = oItem.mmid
            ? '//s3.amazonaws.com/bookspan-media/covers/full/' + oItem.mmid + '.jpg'
            : 'images/products/product_placeholder.png';
          return (
            <li key={oItem.mmid}>
              <div
              className="remove inline"
              onClick={() => dispatch(removeProductFromWishlist(oItem))}
              >
                <svg version="1.1"x="0px" y="0px"
                     width="22.666px" height="22.667px" viewBox="0 0 22.666 22.667" enable-background="new 0 0 22.666 22.667" >
                  <circle id="bgFill" fill="#FFFFFF" cx="11.436" cy="11.108" r="9.522"/>
                  <path fill="#231F20" d="M11.379,22.325c-6.108,0-11.078-4.969-11.078-11.077S5.271,0.169,11.379,0.169s11.077,4.97,11.077,11.078
                    S17.487,22.325,11.379,22.325z M11.379,2.669c-4.73,0-8.578,3.848-8.578,8.578c0,4.729,3.848,8.577,8.578,8.577
                    c4.729,0,8.577-3.848,8.577-8.577C19.956,6.518,16.108,2.669,11.379,2.669z"/>
                  <polygon fill="#231F20" points="17.634,6.758 15.866,4.991 11.462,9.396 7.057,4.991 5.29,6.758 9.694,11.164 5.29,15.57
                    7.057,17.337 11.462,12.932 15.866,17.337 17.634,15.57 13.229,11.164 "/>
                </svg>
              </div>
              <div className="lp-medalion">{lpMedallion}</div>
              <div className="product-scaled-wrapper">
                <img className="product-scaled" src={sImageSrc} />
              </div>
              <button className="btn-primary" onClick={() => dispatch(moveProductToCart(oItem))}>Move to Box</button>
            </li>
          );
        });
      }
    }

    return (
      <div>
        <div className="modal-header content-max-width">
          <div className="button-wrapper">
            <button className="btn-secondary" onClick={() => dispatch(closeModal())}>Continue shopping</button>
          </div>
          <h2>Wishlist</h2>
        </div>
        <div className="modal-body content-max-width">
          <div className="product-list">
            <ul>
              {oWishlistItems}
            </ul>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'computedCart': state.computedCart,
      'store': state.store
    };
}

export default connect(mapStateToProps)(ModalWishlist);



// WEBPACK FOOTER //
// ./src/components/ModalWishlist.jsx